import React from 'react';
import { ArrowLeft, Sparkles } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

export default function PlaceholderSection({ onBack, title, description }) {
  const { colors } = useTheme();
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-3">
        <button onClick={() => onBack()} className="app-card p-1.5 rounded-md" style={{ background: `linear-gradient(135deg, ${colors.accent}12 0%, ${colors.accent}04 100%)` }}>
          <ArrowLeft className="w-4 h-4" style={{ color: colors.primaryText }} />
        </button>
        <h1 className="text-[17px] font-bold" style={{ color: colors.primaryText }}>{title}</h1>
      </div>
      <div className="app-card rounded-lg p-1.5 text-center" style={{ background: `linear-gradient(135deg, ${colors.accent}12 0%, ${colors.accent}04 100%)`, borderWidth: '1px', borderColor: colors.border }}>
        <Sparkles className="w-10 h-10 mx-auto mb-3" style={{ color: colors.accent }} />
        <p className="text-[14px]" style={{ color: colors.secondaryText }}>{description}</p>
      </div>
    </div>
  );
}
